export default __webpack_public_path__ + "static/media/splash-trainer-right.82fe6e63.svg";